module.exports = __webpack_public_path__ + "img/integrations.38310e91.svg";